export default __webpack_public_path__ + "static/media/c.bc361786.png";